import { createModel } from '@rematch/core';
import { Dispatch } from '../../store';
import { PatientVaccine } from '../../models/patient-vaccine';
import { storeByIMPSId } from '../../utils/converter';
import { getAppointmentPatientVaccines } from '../../apis/patient-vaccine';

export interface State {
    byId: Dictionary<PatientVaccine>;
    loading: Dictionary<boolean>;
}

export const patientVaccines = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<PatientVaccine>>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeByIMPSId(data)
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: dispatch => ({
        async getAppointmentPatientVaccinesAsync(appointmentId: number) {
            const {
                cdcCVXs,
                providers
                // @ts-ignore
            } = dispatch as Dispatch;
            this.loading('getAppointmentPatientVaccinesAsync', true);
            try {
                const data = await getAppointmentPatientVaccines(appointmentId);
                this.update(data, 'getAppointmentPatientVaccinesAsync');

                // Collect related data
                if (data) {
                    providers.getProvidersAsync(data.map(x => x.administeredByProviderId));
                }
                // @ts-ignore
                cdcCVXs.getCDCCVXsAsync();
            } catch (e) {
                window.console.log(e);
                this.loading('getAppointmentPatientVaccinesAsync', false);
            }
        }
    })
});
